import styled from 'styled-components'
import { BP } from 'resources/constants'
import { containerCss } from 'app/sofia/components/Structure/Container'
import { sectionCss } from 'app/sofia/components/Structure/Section'
import { cmsSectionHeroCss, cmsSidebarNavCss } from '../../../../components/Styled'

export const CmsContentWrap = styled.div`
  a {
    ${props => props.theme.css.link};
  }

  .section-hero {
    ${cmsSectionHeroCss}
  }

  .section-content {
    ${sectionCss}
    padding-top: 0 !important;
  }

  .container {
    ${containerCss}

    .content {
      display: flex;
      flex-direction: column-reverse;

      @media (min-width: ${BP.sm.min}) {
        align-items: flex-start;
        flex-direction: row;
      }

      .questions-wrapper {
        > .question {
          border-bottom: 1px solid ${props => props.theme.palette.general.borderColorLight};
          padding: 30px 0;
          scroll-margin-top: 80px;

          &:first-child {
            padding-top: 0;
          }

          &:last-child {
            border-bottom: 0;
            padding-bottom: 0;
          }

          h4 {
            font-weight: 400;
            font-family: ${props => props.theme.font.alt.family};
            font-size: 18px;
            margin: 0 0 20px;
          }

          p {
            margin: 0 0 20px;

            &:last-child,
            &:only-child {
              margin: 0;
            }
          }

          .action {
            text-align: right;

            a {
              ${props => props.theme.css.link};
            }
          }
        }
      }
    }

    .sidebar {
      ${cmsSidebarNavCss}
    }
  }
`
